import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const MoneyDollarBox = memo((props: IconProps) => {
    const { color = "#000", ...rest } = props
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...rest}>
            <path
                fill={color}
                d="M2 2h12a.667.667 0 0 1 .667.667v10.666a.667.667 0 0 1-.666.667H2a.666.666 0 0 1-.667-.667V2.667A.667.667 0 0 1 2.001 2Zm3.667 7.333v1.334h1.667V12h1.333v-1.333h.667a1.667 1.667 0 0 0 0-3.334H6.667a.333.333 0 0 1 0-.666h3.667V5.333H8.667V4H7.334v1.333h-.667a1.667 1.667 0 0 0 0 3.334h2.667a.333.333 0 0 1 0 .666H5.667Z"
            />
        </svg>
    )
})

export default MoneyDollarBox
